import React from "react";
import Heading from "utils/Heading";
import RichText from "utils/RichText";

const QuoteBlockBig = ({ blok }) => {
  return (
    <div className="my-12 lg:my-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div class="block gap-10 lg:flex lg:flex-row">
          <div className="w-full lg:w-2/3">
            <Heading
              size="h3"
              className="!mb-10 !text-4xl lg:!mb-16 lg:!text-[64px] lg:!leading-[4.5rem]"
            >
              {blok.quote}
            </Heading>
            <Heading size="h5" className="!mb-0">
              {blok.name}
            </Heading>
            <Heading size="h5">{blok.job_title}</Heading>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuoteBlockBig;
